import { A2A_TRANSACTIONS_ROUTE, TabConfig } from '../../common';
import a2aLang from '../../lang/a2a';

export const getA2ATabConfig = (): TabConfig[] => [
    {
        label: a2aLang.A2A_TABS.TRANSFER,
        link: A2A_TRANSACTIONS_ROUTE,
    },
];
